module.exports = {"username":"demo.pemkab.gresik","id":"7","group":"pemda","status":"enabled","detil":{"nama":"Demo Pemkab Gresik","nip":"444444444444444444","provinsi_id":"11","provinsi":"Jawa Timur","kabupaten_id":"128","kabupaten":"Kabupaten Gresik","kecamatan_id":null,"kecamatan":null,"kelurahan_id":null,"kelurahan":null,"kantor":"Kabupaten Gresik","kantor_id":"128","kantor_level":"kabupaten"},"roleInfo":{"siroleg":[{"role":"siroleg.pemda.polpp","role_name":"Polpp","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_polpp2.json
// module id = TWri
// module chunks = 10